export interface PromotionResponse {
  exhibition: Promotion;
}

export interface Promotion {
  id: string;
  title: string;
  subTitle?: string;
  startAt?: string;
  endAt?: string;
  coverImageUrls: string[];
  createdAt: string;
  lastUpdatedAt: string;
  isVisible: boolean;
  totalGoodsCount: number;
  details: PromotionDetail[];
}

export interface PromotionDetail {
  id: string;
  units: string;
  sections: PromotionDetailSection[];
  stickyTab?: boolean;
}

export interface PromotionDetailSection {
  title?: string;
  id: string;
}

export interface ResponseGetCouponMoldsPublish {
  success: boolean;
  message: string;
}

export interface ProductCouponErrorResponse {
  code?: string;
  detailMessage?: string;
  message?: string;
}

export interface PublishProductCouponResponse {
  /** 쿠폰 ID */
  couponId?: number;
  /** 쿠폰명 */
  couponName?: string;
  /** 등록일시 */
  createdAt?: string;
  /** 등록자 */
  createdBy?: string;
  /** 수정일시 */
  modifiedAt?: string;
  /** 수정자 */
  modifiedBy?: string;
}

interface PublishProductCouponArrayResponse {
  response?: PublishProductCouponResponse[];
}

/** TODO: 추후 제거 확인 */
export type ResponseGetProductCouponMoldsPublish =
  | ProductCouponErrorResponse
  | PublishProductCouponResponse[];
export type CommonPublishProductCoupon =
  | ProductCouponErrorResponse
  | PublishProductCouponArrayResponse;

export const SECTION_ITEMS_TAB = 'section-items-tab';
export const SECTION_PARAM = 'section=';
